var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-token"},[_vm._v("正在获取授权结果，请稍后...")])
}
var staticRenderFns = []

export { render, staticRenderFns }